/**
 * Величины, на которые в одном наборе эффектов претендуют два `set`
 * (D18.3).
 *
 * Расчёт такой набор отклоняет (`conflictingSet`), но отклоняет он его
 * у того, кто открыл лист. Редактору контента нужно то же знание
 * раньше — в момент, когда мастер выбирает вторую операцию (D53),
 * и в браузере, где расчёта нет. Поэтому проверка живёт здесь: одна
 * на редактор, сервер и движок.
 *
 * Условия сравниваются целиком. Два `set` с разными условиями —
 * законный способ записать взаимоисключение, ради которого условия
 * и заведены; конфликтом считается пара, которая применится вместе:
 * оба без условия или оба с одним и тем же.
 *
 * Проверяется только переданный набор. Спор с эффектом чужой записи —
 * тот же доспех поверх доспеха — здесь не виден: набор для этого
 * пришлось бы собирать по всему листу, а листов у записи много и они
 * разные.
 */
export function conflictingSetTargets(effects) {
    const conflicts = new Set();
    const sets = effects.filter((effect) => effect.op === 'set');
    for (let i = 0; i < sets.length; i += 1) {
        for (let j = i + 1; j < sets.length; j += 1) {
            const left = sets[i];
            const right = sets[j];
            if (left === undefined || right === undefined)
                continue;
            if (left.target !== right.target)
                continue;
            const together = left.condition === null ||
                right.condition === null ||
                JSON.stringify(left.condition) === JSON.stringify(right.condition);
            if (together)
                conflicts.add(left.target);
        }
    }
    return [...conflicts].sort((left, right) => left.localeCompare(right));
}
//# sourceMappingURL=conflicts.js.map